













































import { Emit, Inject, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import ProjectService from "@/entities/project/project.service";

@Component
export default class UpdateProjectDialog extends Vue {
  @VModel({ type: Boolean }) dialog!: boolean;
  @Inject() userAdminDataFn;
  @Inject() provincesFn;
  @Inject() projectsFn;

  @Prop() data!: { [key: string]: any };

  get roles() {
    // console.log('this.userAdminDataFn().roles', this.userAdminDataFn().roles);
    return this.userAdminDataFn().roles;
  }

  selectedRoles = null;

  @Watch('data')
  onDataChange(val) {
    this.selectedRoles = val.roles.map(e => e.id);
  }

  get provinces() {
    return this.provincesFn().provinces;
  }

  projectPeriods = [
    { id: 0, name: 'Khảo sát' },
    { id: 1, name: 'Dự án' },
  ];

  @Emit()
  onSaveDone() {}

  async onSave() {
    let projectService = new ProjectService();
    try {
      let partUpdateRS = await projectService.update({
        ...this.data,
        // roles: this.selectedRoles.map(e => ({ id: e })),
      });
      (this.$root as any).$bvToast.toast(`Cập nhật thành công cho dự án ${this.data.name}`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
      this.dialog = false;
      this.projectsFn().reload();
      this.onSaveDone();
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }
}
